module.exports = __webpack_public_path__ + "img/filter.8c85ae80.svg";